import { type ReactNode } from 'react'
import { Checkbox } from '~/shadcn/ui/form/checkbox'
import { Label } from '~/shadcn/ui/label'
import { cn } from '~/shadcn/lib/utils'

export type ScoreCheckboxValue = { checked: boolean; score: number }

type Props = {
  score: number
  value: boolean
  label: ReactNode
  onChange?: (value: ScoreCheckboxValue) => void
}

export function ScoreCheckbox({ score, value, label, onChange }: Props) {
  return (
    <Label className={cn('flex items-center gap-2 cursor-pointer', 'ml-0')}>
      <Checkbox
        checked={value}
        data-score={score}
        onCheckedChange={(checked) => {
          const scoreValue = Number(
            document
              .querySelector(`[data-score="${score}"]`)
              ?.getAttribute('data-score') || score
          )
          onChange?.({ checked: checked === true, score: scoreValue })
        }}
      />
      <span className="font-medium">{label}</span>
    </Label>
  )
}
